<script setup lang="ts">
import { useShortsFeedStore } from '~/store/shortsFeedStore';
import { useVideoHistoryStore } from '~/store/videoHistoryStore';
import { storeToRefs } from 'pinia';

import { Button } from '~/components/ui/button';

import IconMaterialSymbolsLightPlayArrowRounded from '~icons/material-symbols-light/play-arrow-rounded';

const emit = defineEmits<{
	(e: 'open-feed'): void;
}>();

const feedStore = useShortsFeedStore();
const historyStore = useVideoHistoryStore();
const { videos, isPreloaded, allWatched } = storeToRefs(feedStore);
const { historyItems, isHistoryLoaded } = storeToRefs(historyStore);

const firstVideo = computed(() => {
	const feedVideo = videos.value[0];
	if (feedVideo) return feedVideo;

	const historyVideo = historyItems.value?.[0];
	if (historyVideo) {
		return {
			property: historyVideo.property,
			videoUrl: historyVideo.videoUrl,
			thumbnailUrl: historyVideo.thumbnailUrl
		};
	}
	return null;
});

const hasVideo = computed(
	() =>
		!isPreloaded.value ||
		!isHistoryLoaded.value ||
		!!firstVideo.value ||
		allWatched.value
);

function handleClick() {
	emit('open-feed');
}
</script>

<template>
	<Button
		v-if="hasVideo"
		variant="transparent"
		size="xs"
		:is-client-only="false"
		class="group relative flex items-center gap-2 overflow-hidden rounded-full border-none bg-transparent transition-[transform,background-color,box-shadow] active:scale-95 sm:bg-white/10 sm:pr-3 sm:hover:bg-white/20 sm:hover:shadow-lg sm:hover:shadow-white/10"
		aria-label="Ver vídeos em destaque"
		@click="handleClick"
	>
		<div
			class="relative flex size-11 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-white/60 bg-neutral-800/90 transition-all group-hover:border-white sm:size-10"
		>
			<IconMaterialSymbolsLightPlayArrowRounded
				class="size-5 text-white drop-shadow-md"
			/>
		</div>

		<span class="hidden text-sm font-medium text-white sm:inline">
			Descubra
		</span>
	</Button>
</template>
